export const isChatDebugEnabled = (): boolean =>
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_CHAT_DEBUG === 'true';

export const chatDebugLog = (...args: unknown[]): void => {
  if (isChatDebugEnabled()) {
    console.log(...args);
  }
};

export const chatDebugWarn = (...args: unknown[]): void => {
  if (isChatDebugEnabled()) {
    console.warn(...args);
  }
};

export const chatDebugError = (...args: unknown[]): void => {
  if (isChatDebugEnabled()) {
    console.error(...args);
  }
};

export const describeUnknownPayload = (value: unknown): string => {
  if (value === null) {
    return 'null';
  }

  if (Array.isArray(value)) {
    return `array(length=${value.length})`;
  }

  if (typeof value === 'object') {
    const record = value as Record<string, unknown>;
    const keys = Object.keys(record);
    const history = record.history;

    if (Array.isArray(history)) {
      return `object(keys=[${keys.join(',')}], history.length=${history.length})`;
    }

    return `object(keys=[${keys.join(',')}])`;
  }

  return `type=${typeof value}`;
};

export const describeHistoryEntry = (entry: unknown): string => {
  if (entry === null) {
    return 'null';
  }

  if (typeof entry !== 'object') {
    return `type=${typeof entry}`;
  }

  const record = entry as Record<string, unknown>;
  const keys = Object.keys(record);
  const role = typeof record.role === 'string' ? record.role : 'unknown';

  return `object(keys=[${keys.join(',')}], role=${role})`;
};
